// /src/store/mediaCategoryManagment/reducer.ts

import {
  FETCH_CATEGORIES_REQUEST,
  FETCH_CATEGORIES_SUCCESS,
  FETCH_CATEGORIES_FAILURE,
  MediaCategoryState,
  initialState,
  MediaCategoryActionTypes
} from './types';

const mediaCategoryReducer = (state = initialState, action: MediaCategoryActionTypes): MediaCategoryState => {
  switch (action.type) {
    case FETCH_CATEGORIES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_CATEGORIES_SUCCESS:
      return {
        ...state,
        loading: false,
        categories: [...state.categories, ...action.payload.categories],
        lastFetchTimestamp: new Date().getTime()
      };

    case FETCH_CATEGORIES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default mediaCategoryReducer;
